<h2 mat-dialog-title translate="CALLS.ADMIN.SOFT_DELETION.UNMARK_TITLE"></h2>
<mat-dialog-content>
  <p translate="CALLS.ADMIN.SOFT_DELETION.UNMARK_DESCRIPTION"></p>
  @if (canMoveDeletionDates) {
    <mat-checkbox [(ngModel)]="moveDeletionDates" name="move-deletion-dates" [disabled]="mustMoveDeletionDates">
      {{ 'CALLS.ADMIN.SOFT_DELETION.UNMARK_MOVE_DELETION_DATES' | translate }}
    </mat-checkbox>
  }
  @if (moveDeletionDates) {
    <div class="date-picker-section">
      <app-datetime-picker
        [(ngModel)]="softDeletionDate"
        name="soft-deletion-date"
        translationKey="CALLS.ADMIN.SOFT_DELETION.UNMARK_SOFT_DELETION_DATE_LABEL"
        [isDateInvalid]="!areDatesValid"
        errorMessageKey="CALLS.ADMIN.SOFT_DELETION.UNMARK_DELETION_DATES_MUST_BE_LATER"
      ></app-datetime-picker>
      <app-datetime-picker
        [(ngModel)]="deletionDate"
        name="deletion-date"
        translationKey="CALLS.ADMIN.SOFT_DELETION.UNMARK_DELETION_DATE_LABEL"
        [isDateInvalid]="!areDatesValid"
        errorMessageKey="CALLS.ADMIN.SOFT_DELETION.UNMARK_DELETION_DATES_MUST_BE_LATER"
      ></app-datetime-picker>
      <p class="local-time">{{ 'COMMON.ALL_TIMES_IN_TIME_ZONE' | translate: { timeZone: localTimeZone } }}</p>
    </div>
  }
</mat-dialog-content>
<mat-dialog-actions class="actions" align="end">
  <button mat-button [mat-dialog-close]="null" translate="COMMON.CANCEL"></button>
  <button mat-button [mat-dialog-close]="dialogResult" [disabled]="!areDatesValid" translate="COMMON.SAVE" color="primary" cdkFocusInitial></button>
</mat-dialog-actions>
